import { InjectionToken } from '@angular/core';
import { Request, Response } from 'express';

import { Config } from '@spartacus/core';

import { WebCommonConfig } from '../config/configs/web-common.config';
import { CustomBaseStore } from '../models/custom-base-store.model';

export const SERVER_REQUEST = new InjectionToken<Request>('Server Request');
export const SERVER_RESPONSE = new InjectionToken<Response>('Server Response');
export const SERVER_BASESTORE = new InjectionToken<CustomBaseStore>('SsrBaseStore');
export const SERVER_WEBCONFIG = new InjectionToken<WebCommonConfig>('SsrWebCommonConfig');
export const SERVER_CONFIG = new InjectionToken<Config>('ServerConfig');
